/**
 * Created by Alex Xia on 10/25/2018.
 * Description:
 * Add contact header component
 *
 * ------ maintenance history ------
 * Modified by Bowen Li on 2019/7/8: clear the tooltip on ipad
 */
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { ContextMenuConfig } from '../../widgets/tam-context-menu/tam-context-menu.model';
import { ContactDetailConfig } from './contact-detail.config';
import { StoreQuerierService } from '../../services/store-querier.service';
import { ScreenActionTypes } from '../../redux/actions/screen.actions';
import { Router } from '@angular/router';
import { SystemUser } from '../../tamalelibs/models/user.model';
import { EntityType } from '../../tamalelibs/models/entity-type.model';
import { ScreenHelperService } from '../../services/screen-helper.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { ContactTemplateService } from '../contact-dialog-new/contact-template.service';
import { ContactTemplateOpenOptions, ContactTemplateType } from '../contact-dialog-new/contact-dialog.model';
import { SlideSheetService } from '../../services/slide-sheet.service';
import { SlideSheetActionTypes } from '../slide-sheet/slide-sheet.model';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'contact-header',
    templateUrl: './contact-header.component.html',
    styleUrls: ['./contact-header.component.scss']
})
export class ContactHeaderComponent implements OnInit {
    @Input() config: ContactDetailConfig;
    @Input() eventKey?: string;
    @Input() eventValue?: string;
    @ViewChild(TooltipDirective, { static: false })
    public toolTipDir: TooltipDirective;

    contextMenuConfig: ContextMenuConfig;
    isPPCUser = false;
    contactStatus$: Observable<string>;
    jobTitlesName = '';

    private _currentUser: SystemUser;
    private _isIPAD = false;

    constructor(
        private _deviceService: DeviceDetectorService,
        private _storeQuerier: StoreQuerierService,
        private _screenHelperService: ScreenHelperService,
        private _router: Router,
        private _slideSheetService: SlideSheetService,
        private _store: Store<string>,
        private _contactTemplateService: ContactTemplateService,
    ) {
        this._isIPAD = this._deviceService.isMobile() || this._deviceService.isTablet();
    }

    ngOnInit() {
        this._currentUser = this._storeQuerier.getCurrentUser();
        // PPC user can save
        this.isPPCUser = this._currentUser.credential.publishPubConfiguration;
        this.getContactJob();
    }

    diableLink(event: Event) {
        event.preventDefault();
    }

    goToContactDetail() {
        const currentPageInfo: any = {
            name: '',
            type: 'ContactDetial'
        };
        this._store.dispatch({
            type: ScreenActionTypes.SET_VALUE,
            payload: currentPageInfo
        });
        this._router.navigate(['contact', this.config.contact.id]);
        this._slideSheetService.slideSheetActionSubject$.next({
            type: SlideSheetActionTypes.CLOSE,
            payload: ''
        });
    }

    editContact() {
        const _contactDialogOpenOptions = new ContactTemplateOpenOptions();
        _contactDialogOpenOptions.openType = ContactTemplateType.EditContact;
        _contactDialogOpenOptions.contact = this.config.contact;
        _contactDialogOpenOptions.eventKey = this.eventKey;
        _contactDialogOpenOptions.eventValue = this.eventValue;
        if (this.config.contact) {
            this._contactTemplateService.dialogOpen$.next(_contactDialogOpenOptions);
        }
        if (this._isIPAD) {
            this.toolTipDir.showOn = 'none';
        }
    }

    onSaveClick() {
        this._screenHelperService.saveScreen$.next();
    }

    getContactJob() {
        if (this.config.contact && this.config.contact.jobTitleWeb && this.config.contact.jobTitleWeb.length > 0) {
            this.jobTitlesName = this.config.contact.jobTitleWeb.filter(item => item.id).map(res => res.name).join(',');
            if (this.config.contact.companyWeb && this.config.contact.companyWeb.name) {
                this.jobTitlesName = this.jobTitlesName + ' at ' + this.config.contact.companyWeb.name;
            }
        }
    }

    canEdit() {
        // if entity is team, need manageTeam credential
        if (this.config.contact && this.config.contact.type.id === EntityType.TEAM.id) {
            return this._currentUser.credential.manageTeam;
        } else {
            return true;
        }
    }
}
